module.exports = __webpack_public_path__ + "static/media/76.eb6901d9.jpg";